import { ReactNode } from 'react';
import clsx from 'clsx';

type Tone = 'neutral' | 'positive' | 'negative' | 'warning' | 'accent';

const tones: Record<Tone, string> = {
  neutral:  'bg-whisper text-ink',
  positive: 'bg-positive/10 text-positive',
  negative: 'bg-negative/10 text-negative',
  warning:  'bg-[#A87B2A]/10 text-[#A87B2A]',
  accent:   'bg-accent/15 text-[#7A5A3A]',
};

export function Badge({ tone = 'neutral', children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return (
    <span className={clsx('inline-flex items-center h-5 px-1 rounded-sm text-xs font-medium tracking-tight', tones[tone], className)}>
      {children}
    </span>
  );
}
